import React, { useState } from "react";
import {
  DropDownStyled,
  NikeDesignSystemProvider,
  PullQuote,
} from "@nike/nike-design-system-components";
import { Button } from "@nike/epic-react-ui";
import Header from "../components/Header";
import data from "../config/adGrps.json";
import { useNavigate } from "react-router-dom";
import config from "../config/config.js";
import { ROUTE_PALLET_GROUP_ASSIGNMENT } from "../constants/routes";
import { DC_SITE_CODE, DC_SITE_LABEL } from "../constants/site";
import "./component.css";

/** Suppress NDS floating label (e.g. DC*) after a site is selected. */
function HiddenFloatingLabel() {
  return null;
}

function HomePage(props) {
  const [dcValue, setDcValue] = useState("");
  const [dcLabel, setDcLabel] = useState("");
  const [validDc, setValidDc] = useState(false);
  const navigate = useNavigate();

  const handleDcValue = (dc) => {
    setDcLabel(dc.target.selectedOptions[0].label);
    setDcValue(dc.target.value);
    setValidDc(dc.target.value === DC_SITE_CODE);
  };

  const handleOnSubmit = async () => {
    const env = config.isProd ? "prod" : "non-prod";
    const dbAdGrps = data.adGrps
      .filter((envAdGrps) => envAdGrps.env.startsWith(env))[0]
      .dcS.filter((grp) => grp.locationCode === DC_SITE_CODE)[0].grps;

    navigate(ROUTE_PALLET_GROUP_ASSIGNMENT, {
      state: { dc: dcValue, adGroups: dbAdGrps, dcLabel: dcLabel },
    });
  };

  return (
    <div>
      <Header
        handleLogout={props.handleLogout}
        displayLogout={props.displayLogout}
      />
      <div
        id="homePage"
        className="eds-flex eds-flex--direction-column eds-flex--justify-content-center eds-gap--8 container-home"
      >
        <NikeDesignSystemProvider>
          <PullQuote
            text="Welcome to DECON Pallet Group. Select the ELCLKDL site to continue."
          />
          <DropDownStyled
            name="dcSelect"
            id="dcSelect"
            className="home-dc-dropdown"
            label="DC site"
            Label={HiddenFloatingLabel}
            value={dcValue}
            placeholder="DC"
            error={false}
            autoComplete="off"
            disabled={false}
            supportText="DECON flow for ELCLKDL"
            options={[{ label: DC_SITE_LABEL, value: DC_SITE_CODE }]}
            errorMessage="Error message"
            onChange={(event) => handleDcValue(event)}
            ariaLive="polite"
          />

          <Button
            className="home-continue-button"
            large
            type="NikeApp"
            test-id="save-button"
            disabled={!validDc}
            disabledTip={{
              message: "DC Site is a Mandatory field",
              position: "right",
              size: "medium",
            }}
            onClick={() => handleOnSubmit()}
            theme={{
              primary: validDc ? "#000000" : "rgba(215,250,215,0.62)",
              secondary: validDc ? "#ffffff" : "rgba(165,165,165,0.62)",
            }}
          >
            Continue
          </Button>
        </NikeDesignSystemProvider>
      </div>
    </div>
  );
}

export default HomePage;
